<template>
  <div class="step-transition step-wrapper" ref="step-wrapper">
    <transition appear name="fade" mode="out-in">
      <slot></slot>
    </transition>
    <div class="scroll-arrow"></div>
  </div>
</template>

<script>
export default {
  name: 'StepTransition'
}
</script>

<style lang=scss>
.step-transition {
  display: flex;
  flex-grow: 1;
  width: 100%;
  flex-direction: column;
  .scroll-arrow {
    cursor: pointer;
    opacity: 0;
    width: 60px;
    height: 60px;
    position: fixed;
    bottom: 30px;
    right: 30px;
    border-radius: 50%;
    transition: opacity $fast-transition, $color-transition;
    background-repeat: no-repeat;
    background-position: center;
    background-color: rgba($primary-text-color, 0.7);
    background-image: url('../assets/icons/scroll-arrow.svg');
    &:hover {
      background-color: rgba($primary-text-color, 0.9);
    }
    &:active {
      background-color:rgba($primary-text-color, 1);
    }
    &.blink {
      animation-duration: 1s;
      animation-name: scale-easeInElastic;
      animation-iteration-count: infinite;
    }
  }
}

@keyframes scale-easeInElastic {
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(1.1);
  }

  100% {
    transform: scale(1);
  }
}
</style>
